import { Box } from "@mui/material";
import React from "react";
import FilterAndSortButton from "./filterAndSortButton.tsx";
import SearchField from "../../../../../common/components/SearchField/searchField.tsx";

interface WebFiltersProps {
  handleClick: (event: React.MouseEvent<HTMLElement>, label: string) => void;
  handleSearchTicket: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  searchValue: string;
  filterValue: string;
  sortByValue:string;
  sortByOrder:string
}

const WebFilters: React.FC<WebFiltersProps> = ({
  handleClick,
  handleSearchTicket,
  searchValue,
  filterValue,
  sortByValue,
  sortByOrder
}) => {
  return (
    <Box className="md:flex flex-row pb-2 gap-4 hidden">
      <Box className="flex gap-4 ">
        <FilterAndSortButton
          handleClick={handleClick}
          filterValue={filterValue}
          sortByValue={sortByValue}
          sortByOrder={sortByOrder}
          sx={{
            color: "black",
            borderColor: "#D3D3DB",
            textTransform: "none",
            paddingLeft: "2rem",
            paddingRight: "2rem",
          }}
        />
      </Box>
      <SearchField
        style={{ padding: "2px 10px 2px 0px", fontSize: "14px" }}
        sx={{ marginLeft: 1, flex: 1, padding: 0 }}
        handleSearchTicket={handleSearchTicket}
        placeHolder="Search Ticket"
        searchValue={searchValue}
      />
    </Box>
  );
};

export default WebFilters;
